<template>
    <common-panel
            v-model="value"
            :image="image"
            :is-read-only="readOnly"
            :width-style="widthStyle"
            :related-url="relatedUrl"
            :validation-lists="validationLists"
            :translate-obj="translateObj"
            :element-author-display="elementAuthorDisplay"
            @close="closePanel"
            @changeTranslate="changeTranslate"
    >

        <template slot="t-description-text">
            행동, 결정 등의 값들에 대한 정의 (UI 혹은 API)
        </template>

        <template slot="t-generation-text">
            Commands become the inbound Adaptor implementations and the Port methods of the Aggregate Root according to the Hexagonal / Clean Architecture.
        </template>

        <template slot="t-edit-user">
            <div
                    v-if="newEditUserImg.length > 0 && readOnly"
                    style="text-align:center"
            >
                <v-chip
                        small
                        color="orange"
                        text-color="white"
                        style="font-weight:bold">
                    <v-avatar left>
                        <v-icon>mdi-lead-pencil</v-icon>
                    </v-avatar>
                    {{newEditUserImg[0].name}} is now editing...
                </v-chip>
            </div>
        </template>



        <template slot="element">
            <div>
                <v-card flat>
                    <v-card-text>
                        <v-col>
                            <v-radio-group v-model="value.isRestRepository" :disabled="readOnly"
                                           style="margin-left:-13px;" row>
                                <v-radio label="RestRepository" :value="true"></v-radio>
                                <v-radio label="Controller" :value="false"></v-radio>
                            </v-radio-group>
                            <span class="panel-title" style="margin-left:-10px;">Associated Aggregate</span>
                            <v-text-field
                                    v-model="value.aggregate.name"
                                    label="Attach Aggregate && check Name"
                                    single-line
                                    disabled
                                    style="margin-left:-10px; margin-top:-15px; min-width:105%;"
                            ></v-text-field>


                            <span class="panel-title" style="margin-left:-10px;">Setting</span>

                            <v-col v-if="value.isRestRepository">
                                <v-autocomplete
                                        :disabled="readOnly"
                                        v-model="value.restRepositoryInfo.method"
                                        :items="getRestfulList"
                                        style="margin-left: -22px; min-width:111%;"
                                        label="Method"
                                        persistent-hint>
                                </v-autocomplete>
                            </v-col>


                            <v-col v-else>
                                <v-row style="align-items: center">
                                    <v-text-field
                                            v-model="value.controllerInfo.apiPath"
                                            :disabled="readOnly"
                                            style="margin-left: -10px; min-width:105%;"
                                            label="API Path"
                                            :prefix="`${elementPrefix}`"
                                    ></v-text-field>
                                </v-row>
                                <v-autocomplete
                                        v-model="value.controllerInfo.method"
                                        :disabled="readOnly"
                                        style="margin-left: -22px; min-width:111%;"
                                        label="Method"
                                        persistent-hint
                                        :items="getControllerList"
                                ></v-autocomplete>
                                <event-storming-attribute
                                        v-model="value.fieldDescriptors"
                                        :entities="entities"
                                        :isReadOnly="readOnly"
                                        :type="value._type"
                                        :elementId="value.elementView.id"
                                        style="margin-left: -22px; margin-right: -22px;"
                                ></event-storming-attribute>
                            </v-col>

                            <span class="panel-title" style="margin-left:-10px;">Httpie command usages</span>
                            <v-row style="align-items: center;">
                                <v-btn icon small @click="copyRestRepositoryMethod()"
                                       style="align-self: start; margin-top: 15px;">
                                    <v-icon small> mdi-content-copy</v-icon>
                                </v-btn>
                                <v-textarea
                                        v-model="httpCommand"
                                        solo
                                        class="mx-2"
                                        style="margin-top: 20px;"
                                        rows="3"
                                ></v-textarea>
                            </v-row>
                        </v-col>
                    </v-card-text>
                </v-card>
            </div>
        </template>
    </common-panel>
</template>


<script>
    import CommonPanel from "./CommonPanel";
    import EventStormingModelPanel from "../EventStormingModelPanel";

    var googleTranslate = require('google-translate')(process.env.VUE_APP_TRANSLATE_KEY);
    var changeCase = require('change-case');
    var pluralize = require('pluralize');

    export default {
        mixins: [EventStormingModelPanel],
        name: 'command-panel',
        props:{
            entities: {
                type: Object,
                default: function () {
                    return {}
                }
            },
        },
        components: {
            CommonPanel
        },
        data() {
            return {
                show: false,
                httpCommand : null,
            }
        },
        computed: {
            getRestfulList(){
                return this.restfulList.slice(1)
            },
            getControllerList(){
                return this.restfulList.slice(4,5)
            },
            elementPrefix(){
                var me = this
                if(me.value){
                    if(me.value.isRestRepository){
                        return null
                    }else{
                        if(me.value && me.value.aggregate.name){
                            var aggName = me.value.aggregate.name
                            return `/${pluralize(changeCase.camelCase(aggName))}/{id}/`;
                        }else{
                            return '/{ Aggregate }/{id}/'
                        }
                    }
                }
                return null

            },
        },
        beforeDestroy() {

        },
        created: function () {
            this.panelInit()
        },
        watch: {
            "value.controllerInfo.apiPath":function(newVal){
                this.setHttpCommand()
            },
            "value.restRepositoryInfo.method":function(newVal){
                this.setHttpCommand()
            },

            "value.isRestRepository":function(newVal){
                this.setHttpCommand()
            },
            "value.name":function(newVal){
                this.setHttpCommand()
            },
        },
        methods: {
            panelInit(){
                var me = this
                // Element
                me.findAssociatedAggregate()
                me.relatedUrl = 'https://intro-kor.msaez.io/tool/event-storming-tool/#%C2%B7-command-sticker'

                // Common
                me.$super(EventStormingModelPanel).panelInit()
            },
            setApiPath(){
                var me = this
                if( me.value.controllerInfo.apiPath ){
                    // var lowerCase = JSON.parse(JSON.stringify(me.value.controllerInfo.apiPath)).toLowerCase()
                    // lowerCase = lowerCase.replace(' ', '');
                    // me.value.controllerInfo.apiPath = lowerCase
                }else{
                    var getName = me.value.name
                    var lowerCase = JSON.parse(JSON.stringify(getName)).toLowerCase()
                    lowerCase = lowerCase.replace(' ', '');
                    me.value.controllerInfo.apiPath = lowerCase
                }
            },
            async changedNamePanel(newVal) {
                var me = this
                // element 전달.
                me.canvasbase.$refs[`${me.value.elementView.id}`][0].namePanel = newVal.replace(/\n/g, "").replace(/ /gi, "")

                var translateObj = await me.getTranslate(newVal);
                me.usedTranslate = translateObj.usedTranslate
                me.translateText = translateObj.translateText
            },
            getTranslate(newVal) {
                try {
                    return new Promise(async function (resolve) {
                        googleTranslate.detectLanguage(newVal, function (err, detection) {
                            if (detection.language != 'en') {
                                googleTranslate.translate(newVal, 'en', function (err, translation) {
                                    var obj = {
                                        'usedTranslate': true,
                                        'translateText': changeCase.pascalCase(translation.translatedText)
                                    }
                                    resolve(obj)
                                });
                            }
                        });
                    })
                } catch (e) {
                    return undefined;
                }
            },
            setHttpCommand(){
                var me = this
                var aggName = 'aggs'
                var fieldDescriptorsName = 'aggFieldName'

                if(me.value && me.value.aggregate.name){
                    aggName = me.value.aggregate.name
                    aggName = pluralize(changeCase.camelCase(aggName))
                    aggName = aggName.toLowerCase()

                    if(me.value.aggregate.aggregateRoot && me.value.aggregate.aggregateRoot.fieldDescriptors.length > 1 ){
                        fieldDescriptorsName = ''
                        me.value.aggregate.aggregateRoot.fieldDescriptors.forEach(function (fieldItem) {
                            if(!fieldItem.isKey){
                                fieldDescriptorsName = fieldDescriptorsName.concat(`${fieldItem.name}="value" ` )
                            }
                        })
                    }
                }



                if(me.value.isRestRepository){
                    if(me.value.restRepositoryInfo.method == 'POST'){
                        me.httpCommand = `http POST localhost:8080/${aggName} ${fieldDescriptorsName}`
                    }else if(me.value.restRepositoryInfo.method == 'PATCH'){
                        me.httpCommand = `http PATCH localhost:8080/${aggName}/1 ${fieldDescriptorsName}`
                    }else if(me.value.restRepositoryInfo.method == 'DELETE'){
                        me.httpCommand = `http DELETE localhost:8080/${aggName}/1`
                    }else if(me.value.restRepositoryInfo.method == 'PUT'){
                        me.httpCommand = `http PUT localhost:8080/${aggName}/1 ${fieldDescriptorsName}`
                    }
                    // var fieldDescriptorsName =  'FieldName'
                }else{
                    me.setApiPath()
                    me.httpCommand = `http PUT localhost:8080/${aggName}/1/${me.value.controllerInfo.apiPath}`
                }

            },
            copyRestRepositoryMethod(){
                const t = document.createElement("textarea");
                document.body.appendChild(t);
                t.value = this.httpCommand
                t.select();
                document.execCommand('copy');
                document.body.removeChild(t);

                this.$EventBus.$emit('snackbar', {show :true, text : 'Copied to clipboard!', timeout: 1000 ,bottom: true })
            }
        }
    }
</script>
